import { render, staticRenderFns } from "./hero-stand.vue?vue&type=template&id=20270b9f&scoped=true&"
import script from "./hero-stand.vue?vue&type=script&lang=js&"
export * from "./hero-stand.vue?vue&type=script&lang=js&"
import style0 from "./hero-stand.vue?vue&type=style&index=0&id=20270b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20270b9f",
  null
  
)

export default component.exports